// extracted by mini-css-extract-plugin
module.exports = {"score":"Score_score__Egp5d"};